import { useEffect,useState } from 'react';
import { KTIcon } from '../../../../_metronic/helpers';
import axios from 'axios';
import { AddSubs } from './Components/ModalSubs';
import { Modaldeploy } from './Components/Deploy';
import { useNavigate } from 'react-router-dom';
import { getSubscriptionsList,getSubscriptionsListglobal } from './request/request';
import { FeaturesUpdate } from './Components/ModalFeatures';
import { useAppSelector } from '../../../../redux/hooks';
import Swal from 'sweetalert2';
import { useAuth } from '../../auth';

const API_URL = process.env.REACT_APP_API_URL

type ID = undefined | null | number

function FeaturesCrud() {
    const{currentUser}= useAuth()
    const tenant= useAppSelector(state =>state.TenantSlice.id)



    /* variable para el modal  */
    const [ ID , setID]=useState<ID>(undefined)
    const [ IDdeploy , setIDeploy]=useState<ID>(undefined)

    const [ ten , setten]=useState<any>()
    /*__________________________*/

    const navigate= useNavigate()
    const [records,setRecords]= useState<any|null>([ ])



    /**********************Llamada a axios y parse de data**********************/

    useEffect( () => {
      if (currentUser?.ListPermiso?.includes('Tenant.list')){
         if(tenant ===0){
            getSubscriptionsList().then(response=>{
                setRecords(response.data)
            })
         }
         else if(tenant !==0){
           getSubscriptionsList().then(response=>{
                setRecords(response.data)
            })
         }
        }
        }, [tenant])

     

    /***********************************************************************************/
  
    


    return(
        <>
        <div className='card'>
        {/* begin::Header */}
        <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column '>
            <span className='f-titulo text-marino fs-md '>Subscription Management</span>
            </h3>
            {/*Se agrega Boton para agregar Subscription*/}
            <div className='card-toolbar'>
                {/*currentUser?.ListPermiso?.includes('Roles.Create') &&*/ <button onClick={ () => setID(null)} className='btn-light-marino f-parrafo'> Add Subscription</button>}
                
                {/*currentUser?.ListPermiso?.includes('Roles.Create') &&*/ <button onClick={ () => setIDeploy(null)} className='btn-light-marino f-parrafo' style={{marginLeft:'10px'}}> Deploy</button>}
            </div>
        </div>

        {/* end::Header */}

        {/* begin::Body */}
        <div className='card-body py-3'>
            <div className='tab-content'>
            {/* begin::Tap pane */}
            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                {/* begin::Table container */}
                <div className='table-responsive'>

                {/* begin::Table */}
                    <table className='w-full f-parrafo  caption-bottom  custom-table' id='table'>
                        {/* begin::Table head */}
                        <thead>
                
                            <tr className="text-azul text-left">
                                <th className='table-cell'>Id</th>
                                <th className='table-cell'>Subscription Name</th>
                                <th className='table-cell'>Start Date</th>
                                <th className='table-cell'>End Date</th>
                                <th className='table-cell'>Update</th>

                            </tr>
                        </thead>
                        {/* end::Table head */}


                        {/* begin::Table body */}
                        <tbody>
                            {records.map((d:any,i:any)=>(
                                    <tr key={i} className='table-row'>
                           
                                        <td className='table-cell'>{d.id}</td>
                                        <td className='table-cell'>{d.purchaseOrden}</td>
                                        <td className='table-cell'>{d.startDate}</td>
                                        <td className='table-cell'>{d.endDate}</td>


                                        <td className='table-cell'>
                                            <button className='btn-light-marino f-parrafo' 
                                            onClick={ () => (setID(d.id) ,setten(d.tenantId)) }
                                            >Update Features</button>            
                                      
                                        </td>
                                    </tr>
                                ))
                            }

                        </tbody>
                          {/* end::Table body */}

                    </table>
                     {/* end::Table */}
                </div>
               

            </div>
            {/* end::Tap pane */}
            </div>
        </div>
        {/* end::Body */}
        </div>
        
        {ID !== undefined && <AddSubs setID={setID} id={ID} setRecords={setRecords}/>}
        {IDdeploy !== undefined && <Modaldeploy setID={setIDeploy} id={IDdeploy}/>}
        {ID !== undefined && <FeaturesUpdate setID={setID} id={ID} Tenant={ten}/>}
        </>

	);
    function handleSubmit(id:any){
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this Role!",
            showCancelButton:true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          })
          .then((result) => {
            if (result.isConfirmed) {
                if(tenant===0){
                    axios.delete(API_URL+'/v1/rol/'+id)
                    .then(res=>{
                    if  (res.data.status==='successful'){
                    Swal.fire(
                        'Deleted!',
                        'Your Role has been deleted.',
                        'success'
                    );}
                    else{
                        Swal.fire(
                            'error!',
                            'your role could not be eliminated!',
                            'error'
                        );
                    }
                    getSubscriptionsList().then(response=>{
                        setRecords(response.data)
                    })
                })
                   

                }
                else{
                    axios.delete(API_URL+'/v1/rol/'+id+'?tenantId='+tenant)
                    .then(res=>{
                        if  (res.data.status==='successful'){
                            Swal.fire(
                                'Deleted!',
                                'Your Role has been deleted.',
                                'success'
                            );}
                            else{
                                Swal.fire(
                                    'error!',
                                    'your role could not be eliminated!',
                                    'error'
                                );
                            }
                    getSubscriptionsListglobal(tenant).then(response=>{
                        setRecords(response.data)
                    })
                })
                
                }
             
            } else {
              Swal.fire({title:"Your Role is safe!", icon: "success"});
            }
          });
        
        
    }
    }

export default FeaturesCrud